const angular = require('angular');

export default angular.module('nomasvelloDashboardApp.monthlyReport.reportRow', [])
  .directive('monthlyReportRow', function () {
    return {
      template: require('./reportRow.pug'),
      replace: true,
      restrict: 'C'
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/manager/monthlyReport/directives/reportRow/index.ts